import { render, staticRenderFns } from "./Outsource.vue?vue&type=template&id=45054788&"
import script from "./Outsource.vue?vue&type=script&lang=js&"
export * from "./Outsource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports